import { validateDateOfPaymentPer006 } from './validateCommon';
export const validatePer006 = (obj, fieldValidate) => {
  if (fieldValidate?.includes('year_month_payment')) {
    obj.year_month_payment = validateDateOfPaymentPer006;
  }
  return obj;
};
